import Http from '../http'

export default {

  index(filter) {
    return Http.get(`/my_courses`, {params: {...filter}})
  },

}
